export const useAuthToken = () => {
  const tokenCookie = useCookie('token', {
    maxAge: 60 * 60 * 24 * 1, // 1 day
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax'
  })

  const setToken = (token: string) => {
    tokenCookie.value = token
  }

  const clearToken = () => {
    tokenCookie.value = null
  }

  const getToken = () => {
    return tokenCookie.value
  }

  return {
    setToken,
    clearToken,
    getToken
  }
}
